import { configureStore } from "@reduxjs/toolkit";

import authReducer from "./slices/authSlice";
import categoryReducer from "./slices/categorySlice";
import dashboardReducer from "./slices/dashboardSlice";
import formReducer from "./slices/formSlice";
import legislationReducer from "./slices/legislationSlice";
import notificationReducer from "./slices/notificationSlice";
import onboardingStepsReducer from "./slices/onboardingStepsSlice";
import packageReducer from "./slices/packageSlice";
import policyReducer from "./slices/policySlice";
import registrationGroupReducer from "./slices/registrationGroupSlice";
import subCategoryReducer from "./slices/subCategorySlice";
import tagReducer from "./slices/tagSlice";
import themeReducer from "./slices/themeSlice";
import userOnboardingPorgressReducer from "./slices/userOnboardingProgressSlice";
import userReducer from "./slices/userSlice";

export const store = configureStore({
  reducer: {
    theme: themeReducer,
    auth: authReducer,
    dashboard: dashboardReducer,
    package: packageReducer,
    category: categoryReducer,
    subCategory: subCategoryReducer,
    policy: policyReducer,
    legislation: legislationReducer,
    user: userReducer,
    tag: tagReducer,
    notification: notificationReducer,
    registrationGroup: registrationGroupReducer,
    form: formReducer,
    onboardingSteps: onboardingStepsReducer,
    userOnboardingPorgress: userOnboardingPorgressReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export * from "./hooks";
export * from "./interfaces";
export * from "./services";
export * from "./slices";
